import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  deleteResourceByParam,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState = {
  startDateTriggeredCommunicationsById: {},
  startDateTriggeredCommunicationsStateByOrgId: {},
};

export const startDateTriggeredCommunicationReducer = (
  state: any = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('LOAD_START_DATE_TRIGGERED_COMMUNICATIONS'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'startDateTriggeredCommunications', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_START_DATE_TRIGGERED_COMMUNICATIONS'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'startDateTriggeredCommunications',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: StartDateTriggeredCommunication) =>
          String(d.startDateTriggeredCommunicationId),
        ),
      );
    }
    case FAILURE('LOAD_START_DATE_TRIGGERED_COMMUNICATIONS'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(
        state,
        'startDateTriggeredCommunications',
        'orgId',
        orgId,
        false,
      );
    }
    case SUCCESS('CREATE_START_DATE_TRIGGERED_COMMUNICATION'):
    case SUCCESS('UPDATE_START_DATE_TRIGGERED_COMMUNICATION'): {
      const { data } = action.payload;
      const { startDateTriggeredCommunicationId, orgId } = data;

      if (data.deletedAt) {
        return deleteResourceByParam(
          state,
          'startDateTriggeredCommunications',
          'orgId',
          orgId,
          data.startDateTriggeredCommunicationId,
        );
      }
      return updateResourceByParam(
        state,
        'startDateTriggeredCommunications',
        'orgId',
        orgId,
        false,
        { [startDateTriggeredCommunicationId]: data },
      );
    }
    default: {
      return state;
    }
  }
};
